import {
  Dropdown,
  Badge,
  Header,
  Container,
  Content,
  Drawer,
  Footer as FooterRs,
} from "rsuite";
import { images } from "../../assets";
import { Icon, Button, Footer } from "../";
import "./style.scss";
import GarageCard from "../garagecard";
import ScrollBar from "react-perfect-scrollbar";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";
import { getLocalized } from "../../redux/localization";
import { garageCartSelector } from "../../redux/garageCart";
import { useState } from "react";
import { AiOutlineArrowRight, AiOutlineClose } from "react-icons/ai";
import { ButtonType } from "../button";
import ResponsiveFooter from "../footer/responsiveFooter";
const NavbarMenu = () => {
  const history = useHistory();
  const localize = useSelector(getLocalized);
  const garageCart = useSelector(garageCartSelector);
  const [show, setShow] = useState(false);

  return (
    <>
      <Drawer placement="top" open={show} style={{ height: "100vh" }}>
        <Drawer.Body className="drawer-pr drawer-navbar-menu">
          <ScrollBar>
            <div className="w-100 border-bottom border-white">
              <div className="container   d-flex w-100 align-items-center  justify-content-between py-4 ">
                <div
                  className="nav-menu-icon medium-18 text-white navbarMenuItem"
                  onClick={() => setShow(false)}
                >
                  KAPAT <AiOutlineClose size={44} style={{}} />
                </div>
                <div>
                  <img
                    className="g"
                    style={{
                      width: 67,
                      height: "auto",
                      zIndex: "1",
                      position: "relative",
                      marginInlineStart: 2,
                      marginBlockStart: 4,
                      cursor: "pointer",
                    }}
                    src={images.logowhite}
                    alt=""
                    onClick={() => history.push("/")}
                  />
                </div>
                <div style={{ color: "transparent" }}>asdfasdfas</div>
              </div>
            </div>
            <Footer /> <ResponsiveFooter />
          </ScrollBar>
        </Drawer.Body>
      </Drawer>
      <div
        className="w-100 "
        style={{
          boxShadow: "rgb(38 59 94 / 8%) 0px 3px 10px 0px",
        }}
      >
        <div className="container  d-flex w-100 align-items-center  justify-content-between py-3">
          <div
            className="nav-menu-icon light-18 d-flex"
            onClick={() => setShow(true)}
          >
            <span className="navbarMenuItem" style={{ display: "block" }}>
              MENÜ{" "}
            </span>
            <span className="hamburger ms-md-2">
              <span></span>
            </span>
          </div>
          <div>
            <img
              className="navbar-logo-img"
              style={{
                width: 67,
                zIndex: "1",
                position: "relative",
                marginInlineStart: 2,
                marginBlockStart: 4,
                cursor: "pointer",
              }}
              src={images.logo}
              alt=""
              onClick={() => history.push("/")}
            />
          </div>
          <div
            className="garageDropdown-resp"
            onClick={() => history.push("/garage")}
          >
            <Badge color="cyan" content={garageCart.length}>
              <Icon size={28} icon="car-outline" />
            </Badge>
          </div>
          <Dropdown
            className="navbar-dropdown garage garage-dropdown"
            trigger={["click", "hover"]}
            placement="bottomEnd"
            icon={
              <Badge color="cyan" content={garageCart.length}>
                <Icon size={28} icon="car-outline" />
              </Badge>
            }
            style={{
              marginInlineEnd: -11,
            }}
            noCaret
            menuStyle={{
              width: 444,
              height: 481,
              borderRadius: 0,
              border: "1px solid #f5f5f5",
            }}
          >
            <Container>
              <Header className="h2 garagecard-header header-font">
                {localize.getString("mygarage")}
              </Header>
              <Content style={{ height: 317 }}>
                <ScrollBar>
                  {garageCart.map((garageCartItem, i) => {
                    return <GarageCard key={i} data={garageCartItem} />;
                  })}
                </ScrollBar>
              </Content>
              <FooterRs className="navbar-garagecard-footer">
                <Button
                  style={{
                    width: "max-content",
                    marginBlock: 10,
                    marginInlineEnd: 20,
                    fontSize: 24,
                    fontWeight: 700,
                  }}
                  icon={<AiOutlineArrowRight></AiOutlineArrowRight>}
                  buttonType={ButtonType.newColored}
                  title={localize.getString("mygarage").toUpperCase()}
                  onClick={() => history.push("/garage")}
                />
              </FooterRs>
            </Container>
          </Dropdown>
        </div>
      </div>
    </>
  );
};
export default NavbarMenu;
